import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
export function Guarantee() {
  return <section className="w-full bg-canvas px-4 py-16 sm:py-20" data-id="element-161" data-mp="20m4opq90saty">
      <div className="mx-auto max-w-2xl text-center" data-id="element-162" data-mp="24myekp60vzph">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-accept bg-white" data-id="element-163" data-mp="24l3sv8mxg3kc">
          <ShieldCheckIcon className="h-9 w-9 text-accept" aria-hidden="true" data-id="element-164" data-mp="2ed9rh17opj8i" />
          <span className="mt-0.5 text-lg font-black leading-none text-ink" data-id="element-165" data-mp="2jc4bg6he1du7">7 DAYS</span>
          <span className="text-[10px] font-bold uppercase text-muted" data-id="element-166" data-mp="2jdxk1rbka84u">Guarantee</span>
        </div>

        <h2 className="mt-6 font-serif text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-167" data-mp="2o9cwcetx7vz5">
          7-day 100% money-back guarantee. <em className="text-brand" data-id="element-168" data-mp="txocpzcqv58f">Try it risk-free.</em>
        </h2>

        <p className="mt-5 text-[17px] leading-relaxed text-muted" data-id="element-169" data-mp="tzj0dlfehbg7">
          I want you to look through the system before deciding whether it belongs in your clinical workflow. Explore the 6 volumes, use the worksheets,
          review the decision matrix, work through the cases and use the checklists.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-170" data-mp="3ivdidl6yo72p">
          If within the first 7 days you decide Implant Case Decision™ isn't valuable for your practice, simply contact us and{" "}
          <strong className="text-ink" data-id="element-171" data-mp="femwdwuzhjfd">we'll refund 100% of your purchase.</strong> No complicated process. No unnecessary questions.
        </p>
        <p className="mt-5 font-serif text-xl font-bold italic text-ink" data-id="element-172" data-mp="agd1lnd68kua">That's my promise to you.</p>

        <SectionCta label="Try it risk-free for 7 days" data-id="element-173" data-mp="5f5tfn749jn3" />
      </div>
    </section>;
}